import { render, staticRenderFns } from "./ActivityTreeNodeBookmarksView.vue?vue&type=template&id=4cbe1232&lang=pug&"
import script from "./ActivityTreeNodeBookmarksView.vue?vue&type=script&lang=ts&"
export * from "./ActivityTreeNodeBookmarksView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports